import React, { useState } from "react";
import { buttonStyle, MainContainer } from "./styled";
import TreeView from "../TreeView";
import { Grid } from "@mui/material";
import Button from "../Button";
import DialogBox from "../DialogBox";
import { locale } from "../../utils/LocaleManager";
import TextFieldInput from "../Textfield";
import { useFolderStore } from "../../stores/folderStore";
import { newFolder } from "../../services/folderServices";
import { newFolderRequest } from "../../models/folder";
import { Bounce, toast } from "react-toastify";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";
import { handleError } from "../../utils/utilFunctions";

const SideFolderContainer = ({
  isClickedBreadCrumb,
  setIsClickedBreadCrumb,
  isClickedFolder,
}: any) => {
  const rolePermissions = useRolePermissionsStore(
    (state: any) => state.rolePermissions,
  );
  const isShowNewFolder = useFolderStore((state: any) => state.isShowNewFolder);
  const setIsShowNewFolder = useFolderStore(
    (state: any) => state.setIsShowNewFolder,
  );
  const folderId = useFolderStore((state: any) => state.folderId);
  const setIsCreateSuccess = useFolderStore(
    (state: any) => state.setIsCreateSuccess,
  );
  const [folderName, setFolderName] = useState("");
  const [newFolderError, setNewFolderError] = useState("");

  const fetchNewFolder = async (request: newFolderRequest) => {
    try {
      setNewFolderError("");
      const newFolderAPI = await newFolder(request);
      if (newFolderAPI?.status === 200) {
        setIsShowNewFolder(false);
        setFolderName("");
        setIsCreateSuccess(true);
        toast.success(`${folderName} folder was successfully created`, {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          pauseOnFocusLoss: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
          onClose: async () => {
            setIsCreateSuccess(false);
          },
        });
      } else {
        const errorResponse = newFolderAPI?.response;
        const { data } = errorResponse;

        if (!data) return;

        if (data?.content.includes("exists")) {
          setNewFolderError("Folder already exists.");
          return;
        }

        handleError({
          status: errorResponse?.status,
          toast,
          errorMessage: "",
          onClose: () => {},
        });
      }
    } catch (error) {
      console.error("Error creating new folders:", error);

      handleError({
        status: 0,
        toast,
        errorMessage: `Error creating new folders: ${error}`,
        onClose: () => {},
      });
    }
  };

  const renderCreateDialog = () => {
    return (
      <TextFieldInput
        value={folderName}
        onChange={(e: any) => setFolderName(e.target.value)}
        autoFocus={true}
        error={newFolderError?.length > 0}
        helperText={newFolderError}
      />
    );
  };

  const onClickNewFolder = () => {
    setIsShowNewFolder(true);
  };

  const createFolder = () => {
    const id = folderId === 1 ? null : folderId;
    const request: newFolderRequest = {
      name: folderName,
      parentFolderId: id,
    };
    fetchNewFolder(request);
  };

  return (
    <>
      <MainContainer>
        <Grid container>
          <Grid item xs={12}>
            <Button
              variant="variant"
              size="large"
              color=""
              style={buttonStyle}
              onClick={onClickNewFolder}
              disabled={!rolePermissions?.folder?.add}
            >
              + New Folder
            </Button>
          </Grid>
          <TreeView
            isClickedBreadCrumb={isClickedBreadCrumb}
            setIsClickedBreadCrumb={setIsClickedBreadCrumb}
            isClickedFolder={isClickedFolder}
          />
        </Grid>
      </MainContainer>

      {isShowNewFolder ? (
        <DialogBox
          header={locale.new_folder}
          body={renderCreateDialog()}
          subBody={""}
          onCancel={() => {
            setIsShowNewFolder(false);
            setNewFolderError("");
            setFolderName("");
          }}
          onSubmit={() => createFolder()}
          isDelete={false}
          primaryButton={locale.ok}
          secondaryButton={locale.cancel}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default SideFolderContainer;
